import { APIPaths } from "@/apis/api-config";
import BaseApi from "@/apis/base-api";

export class WorkspaceApi extends BaseApi {
  async getWorkspaceList(
    params: APIPaths["/partner-app/workspace/list"]["get"]["parameters"]["query"],
  ): Promise<APIPaths["/partner-app/workspace/list"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.get("/partner-app/workspace/list", { params })).data;
  }
}
